import React from 'react';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import { FMButton } from '@own/fds-react';
import './recall-action-banner.scss';
import { RecallItems } from '../../../services/recalls-service/recalls-service';
import { usePreferredDealer } from '../../../components/sections/vehicle-health-report/hooks/use-preferred-dealer';
import { useAnalytics } from '../../../hooks/use-analytics';
import errorIcon from '../../../assets/Error.svg';
import recallRemedyWarning from '../../../assets/recalls-remedy-warning.svg';

interface RecallsActionProps {
    content: RecallsUnitedContent;
    isCsp: boolean;
    recall: RecallItems;
    vin?: string | null;
    desktopOrLarger?: boolean;
    isWebview: boolean;
    remedyNotAvailable?: boolean;
}

const RecallActionBanner = (props: RecallsActionProps) => {
    const {
        isCsp,
        content,
        recall,
        vin,
        desktopOrLarger,
        isWebview,
        remedyNotAvailable,
    } = props;

    const checkForDoNotDrive = recall?.descriptionLang
        ?.toLowerCase()
        .includes(content?.doNotDriveText?.toLowerCase());
    const buildContent = () => {
        if (checkForDoNotDrive) {
            return {
                title: content?.doNotDriveTitle,
                description: content?.doNotDriveDescription,
            };
        } else if (isCsp) {
            return {
                title: content?.cspScheduleServiceTitle,
                description: content?.cspScheduleServiceDescription,
            };
        } else if (remedyNotAvailable) {
            return {
                title: content?.recallRemedyNotAvailableTitle,
                description: content?.recallRemedyNotAvailableDescription,
            };
        } else {
            return {
                title: content?.recallScheduleServiceTitle,
                description: content?.recallScheduleServiceDescription,
            };
        }
    };
    const bannerContent = buildContent();
    const preferredDealer = usePreferredDealer(vin ?? '')?.dealerResultList[0];
    const scheduleServiceLink = preferredDealer
        ? preferredDealer.scheduleServiceUrl
        : content.recallScheduleServiceCtaLink;
    const [fireEvents] = useAnalytics();
    const recallsResultsCtaClickEvent = 'recalls-results-cta';
    const buttonLabel = remedyNotAvailable
        ? content?.remedyNotAvailableCtaLabel
        : content?.recallScheduleServiceCtaLabel;
    const recallsActionBannerClass = () => {
        if (checkForDoNotDrive) {
            return ' recalls-do-not-drive-mobile-model';
        } else if (remedyNotAvailable) {
            return ' recalls-remedy-not-available-model';
        } else return '';
    };
    const getImageIcon = () => {
        if (checkForDoNotDrive) {
            return errorIcon;
        } else if (remedyNotAvailable) {
            return recallRemedyWarning;
        } else return '';
    };
    const imageIcon = getImageIcon();

    return (
        <div className={`recalls-action-banner${recallsActionBannerClass()}`}>
            {desktopOrLarger && imageIcon && (
                <img
                    loading="lazy"
                    src={imageIcon}
                    alt=""
                    height={24}
                    width={24}
                />
            )}
            <div className="banner-title-desc-container">
                <div className="recalls-action-banner-title">
                    {bannerContent.title}
                </div>
                <div
                    className="recalls-action-banner-description"
                    dangerouslySetInnerHTML={{
                        __html: bannerContent.description,
                    }}
                />
            </div>

            {!isWebview && (
                <div className="recalls-schedule-service-button-container">
                    <FMButton
                        type={'primary'}
                        label={buttonLabel}
                        href={scheduleServiceLink}
                        target={
                            props.content.recallScheduleServiceCtaTargetBlank
                                ? '_blank'
                                : ''
                        }
                        className={`${
                            checkForDoNotDrive || remedyNotAvailable
                                ? 'recalls-do-not-drive-button'
                                : ''
                        }`}
                        onClick={() => {
                            fireEvents(
                                recallsResultsCtaClickEvent,
                                undefined,
                                {
                                    ctaType: buttonLabel,
                                },
                                false
                            );
                        }}
                    />
                </div>
            )}
        </div>
    );
};
export default RecallActionBanner;
